import { render, staticRenderFns } from "./ProductDetail6.vue?vue&type=template&id=59f6900f&scoped=true"
import script from "./ProductDetail6.vue?vue&type=script&lang=js"
export * from "./ProductDetail6.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail6.vue?vue&type=style&index=0&id=59f6900f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6900f",
  null
  
)

export default component.exports